import { createReducer } from "typesafe-actions";

import CoachingNote from "@app/scene/dashboard/types/CoachingNote";

import {
  CoachingNoteWithTaskActions,
  createCoachingNoteWithTask,
  dismissTaskRetry,
  InlineTaskPayload,
  openTaskRetryModal,
  retryCoachingTask,
} from "./actions";

export interface FailedTaskRetry {
  noteId: CoachingNote["id"];
  taskPayload: InlineTaskPayload;
}

export interface CoachingNoteWithTaskState {
  failedTask: FailedTaskRetry | null;
  retrying: boolean;
  submitting: boolean;
}

export const initialCoachingNoteWithTaskState: CoachingNoteWithTaskState = {
  failedTask: null,
  retrying: false,
  submitting: false,
};

const coachingNoteWithTask = createReducer<CoachingNoteWithTaskState, CoachingNoteWithTaskActions>(
  initialCoachingNoteWithTaskState
)
  .handleAction(createCoachingNoteWithTask.request, (state) => ({
    ...state,
    submitting: true,
  }))
  .handleAction(createCoachingNoteWithTask.success, (state) => ({
    ...state,
    submitting: false,
  }))
  .handleAction(createCoachingNoteWithTask.failure, (state) => ({
    ...state,
    submitting: false,
  }))
  .handleAction(openTaskRetryModal, (state, { payload }) => ({
    ...state,
    failedTask: payload,
  }))
  .handleAction(dismissTaskRetry, (state) => ({
    ...state,
    failedTask: null,
  }))
  .handleAction(retryCoachingTask.request, (state) => ({
    ...state,
    retrying: true,
  }))
  .handleAction(retryCoachingTask.success, (state) => ({
    ...state,
    failedTask: null,
    retrying: false,
  }))
  .handleAction(retryCoachingTask.failure, (state) => ({
    ...state,
    retrying: false,
  }));

export default coachingNoteWithTask;
